import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { throttle } from 'lodash';

import rootReducer from './reducers';
import { loadState, saveState } from './localStorage';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const middlewares = [];
  if (process.env.NODE_ENV !== "production") {
    middlewares.push(logger);
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers.js');
      store.replaceReducer(nextRootReducer);
    });
  }

  // Support making action creators that return functions instead of actions
  middlewares.push(thunk);

  const persistedState = loadState();
  const store = createStore(
    rootReducer,
    persistedState,
    composeEnhancers(
      applyMiddleware(...middlewares)
    ),
  );

  store.subscribe(throttle(() => {
    saveState(store.getState());
  }, 1000)); // Only save up to once per second, could handle with RxJS later

  return store;
}

export default configureStore;
